import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import ComputerDesktop from '@/assets/ComputerDesktop.svg';

const Laptop = ({ size, variant, className }: IconProps) => (
  <img
    src={ComputerDesktop}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default Laptop;
